

























































































import { Component, Vue, Watch } from "vue-property-decorator";
import { mapGetters, mapActions } from "vuex";

@Component({
	computed: {
		...mapGetters("qa", ["isLoading", "questions"])
	},
	methods: {
		...mapActions("qa", ["getAllQuestions", "likePostedQuestion"])
	}
})
export default class QA extends Vue {
	search = "";
	isLoading!: boolean;
	questions!: [any];
	getAllQuestions!: any;

	mounted() {
		this.getAllQuestions();
		console.log(this.questions);
	}

	showDetail(id: string) {
		this.$router.push({ name: "QuestionDetail", params: { id } });
	}

	set filteredQuestions(val: any) {
		this.questions = val;
	}
	get filteredQuestions() {
		const q = this.questions.filter((question: any) => {
			return question.title.toLowerCase().match(this.search);
		});
		return q;
	}
}
